import request from "@/utils/httpRequest.js"

export function fetchShareRecord() {
  return request({
    url: 'user/mine',
    method: 'get'
  })
}

/**
 * @param {} data
 */
 export function fetchUserInfo() {
  return request({
    url: 'user/user-info',
    method: 'get'
  })
}

export function updateUserInfo(data) {
  return request({
    url: 'user/user-info',
    method: 'put',
    data
  })
}

export function wechatBind(params) {
  return request({
    url: 'user/wechat-bind',
    method: 'post',
    params
  })
}
